import $ from 'jquery';
import throttle from 'lodash/throttle.js';
import Flyout from './header/Flyout.js';
import {deviceIsMinMd} from '../utilities/media-queries.mjs';

export default class Header {
  constructor(Ui) {
    this.Ui = Ui;
    this.$node = $('#header-wrapper');
    new Flyout();
    deviceIsMinMd.addListener(initShowShadowOnHover.bind(this, deviceIsMinMd));
    initShowShadowOnHover.call(this, deviceIsMinMd);
    initStickyHeader.call(this);
  }

  getHeight() {
    return this.$node.height();
  }
}

/**
 *
 * @param {MediaQueryList} deviceIsMinMd
 */
function initShowShadowOnHover(deviceIsMinMd) {
  if (deviceIsMinMd.matches) {
    let isHovered = false;

    this.$node.on('mouseenter', () => {
      isHovered = true;
      setTimeout(() => {
        if (isHovered) {
          this.Ui.$body.addClass('js_header-hovered');
        }
      }, 250);
    });
    this.$node.on('mouseleave', () => {
      isHovered = false;
      setTimeout(() => {
        if (!isHovered) {
          this.Ui.$body.removeClass('js_header-hovered');
        }
      }, 250);
    });
  } else {
    this.$node.off('mouseenter');
    this.$node.off('mouseleave');
  }
}

/**
 * Copy from ui/ui.js->handleStickyHeader()
 */
function initStickyHeader() {
  this.Ui.$window.on('scroll.Header.stickyHeader', throttle(
    () => {
      const pixelScrolled = this.Ui.$window.scrollTop();
      const totalHeight = this.getHeight();
      const cssClassFixed = 'fixed-top';
      const cssClassSticky = 'sticky-sm-down sticky-md-up';

      if (pixelScrolled > totalHeight) {
        this.Ui.$body.addClass(cssClassSticky);
        // Set Bootstrap default class .fixed-top to allow modal.js
        // fix padding when removing scrollbar
        this.$node.addClass(cssClassFixed);
      } else {
        this.Ui.$body.removeClass(cssClassSticky);
        this.$node.removeClass(cssClassFixed);
      }
    },
    125,
  ));
}

